export default {
	init() {
		// JavaScript to be fired on the home page
		//setup_site_loader();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};

/*function setup_site_loader()
{
	setTimeout(function(){
		let loader = $('.site-loader');
		loader.removeClass('active');
	}, 1500);
}*/



// WEBPACK FOOTER //
// ./scripts/routes/home.js